import {
  EventName,
  EventType,
  RCEvent,
  NetworkEventData,
} from "../eventhub/eventmodels.js";
import { RidecellCallback } from "../models/ridecellcallback.js";
import { NetworkRequests } from "../networkrequestsbuilder.js";
import { EventController } from "../eventhub/eventcontroller.js";

const callbackMethod = (resolve, reject) => {
  const profileCallback = new RidecellCallback();
  profileCallback.onSuccess = function success(result) {
    resolve(result);
  };
  profileCallback.onFailure = (error) => {
    reject(error);
  };
  return profileCallback;
};

export class ProfileManagementController {
  createConsent({ data, queryParams }) {
    return new Promise((resolve, reject) => {
      const consentDecisions = new NetworkEventData(
        EventType.POST,
        NetworkRequests.consentDecisions,
        queryParams, // queryData
        data, // formData
        false // isPatch
      );
      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          consentDecisions,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  createPolicy({ data, queryParams }) {
    return new Promise((resolve, reject) => {
      const policyDecisions = new NetworkEventData(
        EventType.POST,
        NetworkRequests.policyDecisions,
        queryParams, // queryData
        data, // formData
        false // isPatch
      );
      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          policyDecisions,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  getActionRequiredPolicy(queryParams) {
    return new Promise((resolve, reject) => {
      const policyActions = new NetworkEventData(
        EventType.GET,
        NetworkRequests.policyDocsActionsRequired,
        queryParams, // queryData
        false // isPatch
      );
      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          policyActions,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  linkBusinessProfile({ customerId, data }) {
    return new Promise((resolve, reject) => {
      const linkBusiness = new NetworkEventData(
        EventType.PATCH,
        NetworkRequests.linkBusinessProfile(customerId),
        null,
        data
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          linkBusiness,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  deleteMailingAddress(id) {
    return new Promise((resolve, reject) => {
      const mailingAddressInfo = new NetworkEventData(
        EventType.DELETE,
        NetworkRequests.saveMailingAddress(id),
        null,
        null
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          mailingAddressInfo,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  getCards(id) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        NetworkRequests.getCards(id)
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  deleteCard({ customerId, data }) {
    return new Promise((resolve, reject) => {
      const requestInfo = new NetworkEventData(
        EventType.DELETE,
        NetworkRequests.deleteCard(customerId),
        null,
        data
      );
      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestInfo,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  markCardAsDefault({ customerId, data }) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.POST,
        NetworkRequests.markCardAsDefault(customerId),
        null,
        data
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  getAxeptaHostedPage({ customerId, data }) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.POST,
        NetworkRequests.getAxeptaHostedPage(customerId),
        null,
        data
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  /**
   * Passes the event to event controller.
   * @param {RCEvent} event
   */
  sendEvent(event) {
    EventController.addEvent(event);
  }
}
